import { useXmlImport } from '@components/App/Modal/Import/hooks'
import { Button } from '@octopus-do/octopus-storybook'
import { QuestionCircle } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { FileDropzone } from './components'
import css from './styles.module.css'

interface Props {
  teamId?: string
}

export const FileTab: React.FC<Props> = ({ teamId }) => {
  const { file, loading, error, selectFile, clearFile, importXml } =
    useXmlImport({
      teamId,
    })

  const onSubmit = (event?: React.FormEvent) => {
    event?.preventDefault()
    importXml()
  }

  return (
    <form onSubmit={onSubmit}>
      <p className={css.description}>
        Import XML file to generate your sitemap, pages, wireframes, and
        content.
      </p>

      <a
        className={css.file_requirements}
        href="https://help.octopus.do/article/195-how-to-import-a-project"
        target="_blank"
        rel="noreferrer"
      >
        <QuestionCircle />
        File requirements
      </a>

      <FileDropzone
        file={file}
        loading={loading}
        error={error}
        onSelectFile={selectFile}
        onClear={clearFile}
      />

      <Button type="submit" label="Import" loading={loading} disabled={!file} />
    </form>
  )
}
